export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";